import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../hooks';
import {
  resetAllApiStatus,
  fetchLocationsApiThunk,
  createLocationApiThunk,
  updateLocationApiThunk,
  getLocationApiThunk,
} from './locationsSlice';
import { RootState } from '..';
import {
  ListLocationsRequest,
  CreateLocationRequest,
  UpdateLocationRequest,
  GetLocationRequest,
} from 'src/types/helios/Location';
import { get } from 'lodash';

export const useLocations = () => {
  const dispatch = useAppDispatch();
  const locationsList = useAppSelector((state: RootState) => state.locations.locations);
  const fetchLocationsApiStatus = useAppSelector(
    (state: RootState) => state.locations.fetchLocationsApiStatus,
  );
  const getLocationApiStatus = useAppSelector(
    (state: RootState) => state.locations.getLocationApiStatus,
  );
  const createLocationApiStatus = useAppSelector(
    (state: RootState) => state.locations.createLocationApiStatus,
  );
  const updateLocationApiStatus = useAppSelector(
    (state: RootState) => state.locations.updateLocationApiStatus,
  );
  const nextToken = useAppSelector((state: RootState) => state.locations.nextToken);

  // Load locations
  const loadLocations = useCallback(
    (params: ListLocationsRequest) => {
      dispatch(fetchLocationsApiThunk({ isEnabledForBU: true, ...params }));
    },
    [dispatch],
  );

  // Create location
  const createLocation = useCallback(
    (data: CreateLocationRequest) => {
      return dispatch(createLocationApiThunk(data));
    },
    [dispatch],
  );

  // Update location
  const updateLocation = useCallback(
    (data: UpdateLocationRequest) => {
      return dispatch(updateLocationApiThunk(data));
    },
    [dispatch],
  );

  //Get Location
  const getLocation = useCallback(
    (data: GetLocationRequest) => {
      return dispatch(getLocationApiThunk(data));
    },
    [dispatch],
  );

  // Clear API status messages
  const clearAPIStatusMessage = useCallback(() => {
    dispatch(resetAllApiStatus());
  }, [dispatch]);

  return {
    // State
    locationsList,
    nextToken,
    fetchLocationsApiStatus,
    getLocationApiStatus,
    createLocationApiStatus,
    updateLocationApiStatus,
    loadLocations,
    createLocation,
    updateLocation,
    getLocation,
    clearAPIStatusMessage,
  };
};
